import { apiSlice } from "../../api/api";

export const kycApi = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getKycRecords: builder.query({
      query: (params = {}) => ({
        url: "operations/kyc/records",
        method: "GET",
        params: {
          page: params.page || 1,
          search: params.search || "",
          ...params,
        },
      }),
      providesTags: ["KycRecords"],
    }),
  }),
});

export const { useGetKycRecordsQuery } = kycApi;
